<template>
  <div class="xiaoqu">
    <div class="bottom">
      <div class="function">
        <p
          v-for="(item, index) in functionList"
          :key="index"
          :class="index == functionValue ? 'active' : ''"
          @click="changeValue(index)"
        >
          {{ item }}
        </p>
      </div>
      <img
        src="../assets/img/black1.png"
        class="img fadeIn"
        v-show="functionValue == 0"
      />
      <img
        src="../assets/img/black2.png"
        class="img fadeIn"
        v-show="functionValue == 1"
      />
      <img
        src="../assets/img/black3.png"
        class="img fadeIn"
        v-show="functionValue == 2"
      />

      <div class="item">
        <p
          v-for="(item, index) in itemList[functionValue]"
          :key="index"
          :class="index == itemValue ? 'active' : ''"
          @click="changeValue2(index)"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <transition name="my">
      <div class="info" v-if="myFlag" v-click-outside="outside">
        <img :src="img" />
        <a href="http://o2vr.net/upload/jiaju-danjian/#/" >
          <div class="btn">进入户型</div>
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      functionValue: 0,
      itemValue: 99,
      functionList: ["周边配套", "小区漫游", "户型浏览"],
      itemList: [
        ["公园", "教育", "交通", "医疗"],
        ["主入口", "小区景观", "顶楼", "车库"],
        ["高层A", "高层B", "高层C", "小高层D", "洋房E"],
      ],
      imgList: [
        require("../assets/img/A.png"),
        require("../assets/img/B.png"),
        require("../assets/img/C.png"),
        require("../assets/img/D.png"),
        require("../assets/img/E.png"),
      ],
      myFlag: false,
      img: "",
    };
  },
  methods: {
    changeValue(e) {
      let _o2 = document.o2;
      this.functionValue = e;
      this.itemValue = 99;
      console.log(e);

      switch (e) {
        case 0:
          _o2.to_map();
          _o2.hide_manyou();
          _o2.switch_building("");
          break;
        case 1:
          _o2.to_3d();
          _o2.show_manyou();
          _o2.switch_building("");
          _o2.switch_camera(-292, -4684, -242, 15099, 16853, 16262);
          break;
        case 2:
          _o2.to_3d();
          _o2.hide_manyou();
          _o2.switch_camera(-292, -4684, -242, 15099, 16853, 16262);
          _o2.switch_building("");
          break;
      }
    },

    changeValue2(e) {
      this.itemValue = e;
      let _o2 = document.o2;
      switch (e) {
        case 0:
          if (this.functionValue == 0) {
            console.log("公园");
            _o2.to_map();
            _o2.switch_zhoubian("公园");
          } else if (this.functionValue == 1) {
            console.log("主入口");
            _o2.to_3d();
            _o2.hide_manyou();
            _o2.switch_camera(3729, 2256, 10110, 3742, 2363, 10614);
          } else {
            console.log("高层A");
            _o2.switch_building("高层A");
          }
          break;
        case 1:
          if (this.functionValue == 0) {
            console.log("教育");
            _o2.to_map();
            _o2.switch_zhoubian("教育");
          } else if (this.functionValue == 1) {
            console.log("小区景观");
            _o2.to_3d();
            _o2.hide_manyou();
            _o2.switch_camera(-1322, 2397, -2316, -1816, 2504, -2418);
          } else {
            console.log("高层B");
            _o2.switch_building("高层B");
          }
          break;

        case 2:
          if (this.functionValue == 0) {
            console.log("交通");
            _o2.to_map();
            _o2.switch_zhoubian("交通");
          } else if (this.functionValue == 1) {
            console.log("线路1");
            _o2.to_3d();
            _o2.hide_manyou();
            _o2.switch_camera(-3847, 9776, -150, -4087, 10232, -136);
          } else {
            console.log("高层C");
            _o2.switch_building("高层C");
          }
          break;

        case 3:
          if (this.functionValue == 0) {
            console.log("医疗");
            _o2.switch_zhoubian("医院");
          } else if (this.functionValue == 1) {
            console.log("线路2");
            _o2.to_3d();
            _o2.hide_manyou();
            _o2.switch_camera(-8754, 2354, 1862, -8883, 2578, 2308);
          } else {
            console.log("小高层C");
            _o2.switch_building("小高层D");
          }
          break;

        case 4:
          console.log("洋房E");
          _o2.switch_building("洋房E");
          break;
      }
    },

    outside() {
      if (this.myFlag) this.myFlag = false;
    },
  },
  mounted() {
    document.Bus.$on("户型", (e) => {
      console.log(e);
      if (e) {
        this.myFlag = true;
        this.img = this.imgList[this.itemList[2].indexOf(e)];
      }
    });
  },
};
</script>

<style scoped>
/* .xiaoqu {
  position: fixed;
  top: 0;
  left: 0;
} */
.bottom {
  width: 40%;
  height: 105px;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  margin: auto;
}
.img {
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  position: absolute;
}
.function {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-around;
  font-size: 20px;
  line-height: 40px;
}
.function > p {
  color: #283033;
}
.function > .active {
  color: #fff;
}
.item {
  width: 100%;
  position: absolute;
  bottom: 20%;
  z-index: 999;
  display: flex;
  justify-content: space-around;
}

.item > p {
  width: 120px;
  height: 30px;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 30px;
  font-size: 18px;
}
.item > .active {
  color: #333;
  border: 1px solid #fff;
  background-color: white;
  transition: 0.5s;
}
.info {
  width: 40%;

  position: absolute;
  top: 50px;
  left: 50px;
  transition: 0.5s;
  transform: translateX(0px);
}

.info > img {
  width: 100%;
  opacity: 0.8;
}

.my-enter,
.my-leave-to {
  opacity: 0; /*透明度*/
  transform: translateX(-1000px);
}

.my-enter-active,
.my-leave-active {
  transition: all 0.5s ease;
}

.btn {
  width: 120px;
  height: 50px;
  position: absolute;
  left: 20px;
  bottom: 45px;
  margin: auto;
  border: 1px solid #333;
  line-height: 50px;
  text-align: center;
  border-radius: 25px;
  box-shadow: 3px 3px 3px #333;
  color: #333;
}
@media screen and (max-width: 450px) {
  .bottom {
    width: 100%;
    height: 105px;
  }
  .function {
    font-size: 14px;
    line-height: 30px;
  }
  .item{
    bottom: 25%;
  }
  .item > p {
    width: 60px;
    height: 25px;


    border-radius: 10px;
    text-align: center;
    line-height: 26px;
    font-size: 12px;
  }
  .info {
    width: 100%;

    top: 0px;
    left: 0px;
  }

  .btn {
    width: 80px;
    height: 30px;
    position: absolute;
    left: 10px;
    bottom: 25px;
    margin: auto;
    border: 1px solid #333;
    line-height: 30px;
    font-size: 12px;
    color: #333;
  }
}
</style>